/** @public */
export const PRODUCTION_API_ORIGIN = 'https://fleet-app-bd8.onrender.com';
/** @public */
export const LEGACY_PRODUCTION_API_ORIGIN = 'https://fleet-app-lvd8.onrender.com';

type ApiBaseUrlEnv = Pick<ImportMetaEnv, 'VITE_API_BASE_URL' | 'VITE_API_URL'>;

const FRONTEND_HOST_API_MAP: Record<string, string> = {
  'fleet-app-frontend.onrender.com': PRODUCTION_API_ORIGIN,
};

function normalizeConfiguredApiBaseUrl(baseUrl: string | undefined): string {
  let normalized = (baseUrl ?? '').trim();

  if (normalized.startsWith('VITE_API_URL=')) {
    normalized = normalized.slice('VITE_API_URL='.length);
  }

  if (normalized.startsWith('VITE_API_BASE_URL=')) {
    normalized = normalized.slice('VITE_API_BASE_URL='.length);
  }

  if (normalized.startsWith('https:/') && !normalized.startsWith('https://')) {
    normalized = `https://${normalized.slice('https:/'.length)}`;
  }

  normalized = normalized.replace(/\/+$/, '');

  if (!normalized) return '';
  if (normalized === LEGACY_PRODUCTION_API_ORIGIN) return PRODUCTION_API_ORIGIN;

  return normalized;
}

export function resolveApiBaseUrl({
  env,
  locationHostname,
}: {
  env: ApiBaseUrlEnv;
  locationHostname: string;
}): string {
  const normalizedHostname = locationHostname.trim().toLowerCase();
  const isLocalhost = normalizedHostname === 'localhost' || normalizedHostname === '127.0.0.1';

  const configuredBaseUrl = normalizeConfiguredApiBaseUrl(
    env.VITE_API_BASE_URL || env.VITE_API_URL
  );

  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  if (isLocalhost) {
    return '';
  }

  return FRONTEND_HOST_API_MAP[normalizedHostname] ?? '';
}
